var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.018 19.258l1.352-5.853a.626.626 0 01.533-.48l7.558-.783c.213-.018.213-.338 0-.373l-7.558-.73a.587.587 0 01-.533-.462L4.018 4.742c-.124-.498.41-.907.872-.676l14.777 7.4a.623.623 0 010 1.103L4.89 19.934c-.463.23-.996-.178-.872-.676z"
  })));
}
export default __webpack_public_path__ + "fee43d965d49888a9a0f30065b158944.svg";
export { SvgSendArrow as ReactComponent };